import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { calculateTotals } from '@/kenwood/configurator/utils';
import { useConfiguratorContext } from '../../context';

const PriceCounter = () => {
  const { t } = useTranslation();
  const [{ cartData }] = useConfiguratorContext();
  const { promoMessage, dlgSubtotal, subTotal, differentTotals } = useMemo(
    () => calculateTotals(cartData),
    [cartData],
  );
  if (!cartData) return null;
  return (
    <div className='ken-configurator__price-counter'>
      <div className='ken-configurator__price-counter__values'>
        {promoMessage && (
          <span className='ken-configurator__price-counter__discount'>
            {promoMessage}
          </span>
        )}
        <span className='ken-configurator__price-counter__label'>
          {t('configurator:configurator.step2.priceCounter.total')}
        </span>
        <div className='ken-configurator__price-counter__prices'>
          {dlgSubtotal && differentTotals && (
            <span className='ken-configurator__price-counter__insteadOf'>
              {dlgSubtotal}
            </span>
          )}
          {subTotal && (
            <span className='ken-configurator__price-counter__total'>
              {subTotal}
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default PriceCounter;
